import React from 'react';
import { AdsCard } from './AdsCard';
import { AddAds } from './AddAds';
import SubImage from '../Assets/Image/subscription.png';

const content =
  'Subscribing to any of our plans gives you access to transaction';
const tittle = 'Low Transaction Fee';
export const Ads = () => {
  return (
    <div className='grid lg:grid-cols-5 gap-6 py-8'>
      <div className='col-span-3 lg:col-span-2'>
        <AdsCard
          image={SubImage}
          title={tittle}
          paragraph={content}
          buttonText='Subscribe Now'
          to='/subscription'
        />
      </div>
      <div className='col-span-3 min-h-[18rem]'>
        <AddAds />
      </div>
    </div>
  );
};
